export const PERMISSOES = {
  SGI: {
    PAGE_VIEW: {
      USER: 'sgi.page_view:user',
      ADMIN: 'sgi.page_view:admin'
    },

    APLICACOES: {
      LISTAR: 'sgi.aplicacoes:find_all',
      CRIAR: 'sgi.aplicacoes:create',
      EDITAR: 'sgi.aplicacoes:update',
      EXCLUIR: 'sgi.aplicacoes:delete',
    },
    USUARIOS: {
      LISTAR: 'sgi.usuarios:find_all',
      CRIAR: 'sgi.usuarios:create',
      EDITAR: 'sgi.usuarios:update',
      EXCLUIR: 'sgi.usuarios:delete',
    },
    RECURSOS: {
      LISTAR: 'sgi.recursos:find_all',
      CRIAR: 'sgi.recursos:create',
      EDITAR: 'sgi.recursos:update',
      EXCLUIR: 'sgi.recursos:delete',
    },
    FUNCIONALIDADES: {
      LISTAR: 'sgi.funcionalidades:find_all',
      CRIAR: 'sgi.funcionalidades:create',
      EDITAR: 'sgi.funcionalidades:update',
      EXCLUIR: 'sgi.funcionalidades:delete',
    },
    PERFIS: {
      LISTAR: 'sgi.perfis:find_all',
      CRIAR: 'sgi.perfis:create',
      EDITAR: 'sgi.perfis:update',
      EXCLUIR: 'sgi.perfis:delete',
    }
  }
} as const;
